var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app","ng-app":"myApp"}},[_c('router-view',{key:_vm.$route.fullPath}),(_vm.$route.path !== '/common/pdf')?_c('BottomRight'):_vm._e(),(_vm.$route.path !== '/common/pdf')?_c('BottomLeft'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }